<template>
  <v-dialog v-model="openDialog" width="700" persistent>
    <template v-slot:activator="{ on }">
      <mf-button text color="marca-0-l40" :disabled="disabled" :label="buttonText" icon="forward_to_inbox" @click="openDialog = true" />
    </template>
    <v-card>
      <v-card-title>
        <span class="table-card-title">{{ title }}</span>
        <p class="texto-corrido email-subtitle mt-2 mb-0">
          {{ description }}
        </p>
      </v-card-title>
      <include-emails-table ref="includeEmailsTable" :emails.sync="emails" />
      <v-card-actions v-if="async" class="d-flex justify-end mr-2">
        <mf-button class="mr-3" text label="Cancelar" @click="closeModal" />
        <export-data async :loading="exportLoading" :disableXLSX="disableXLSX" @file-format="setFileFormat"></export-data>
      </v-card-actions>
      <mf-action-buttons
        v-else
        class="pb-4 pr-4"
        :primary-button="{
          text: 'Enviar',
          action: exportReport,
          isVisible: true,
          isLoading: exportLoading,
        }"
        :extra-button="{
          text: 'Cancelar',
          action: closeModal,
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import IncludeEmailsTable from './IncludeEmailsTable.vue'
import ExportData from '../export-data/ExportData.vue'
export default {
  name: 'ExportEmailReportDialog',
  components: {
    IncludeEmailsTable,
    ExportData,
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary'].includes(value),
    },
    buttonText: {
      type: String,
      default: 'Enviar relatório',
    },
    iconSize: {
      type: Number,
      default: 20,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    exportReportFn: {
      type: [Function, Promise],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    async: {
      type: Boolean,
      default: false,
    },
    disableXLSX: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    exportLoading: false,
    emails: [],
    openDialog: false,
  }),
  computed: {
    linksClassList() {
      const classList = {
        'pl-4': true,
        'mr-2': true,
        'blue-action-text': !this.disabled,
        'gray-disabled-text': this.disabled,
      }
      return classList
    },
  },

  methods: {
    setFileFormat(value) {
      this.$emit('file-format', value.toUpperCase())
      this.exportReport()
    },
    async exportReport() {
      const isValid = this.$refs.includeEmailsTable.isValid()
      if (!isValid) return

      this.exportLoading = true

      await this.exportReportFn(this.emails)
        .then((data) => {
          this.exportLoading = false
          this.$snackbar({ message: 'E-mail enviado com sucesso', snackbarColor: 'success' })
          this.clearFieldsAndClose()
        })
        .catch((error) => {
          console.log(error)
          this.exportLoading = false
          this.$snackbar({ message: 'Erro ao exportar relatório', snackbarColor: 'error' })
        })
    },
    closeModal() {
      this.$refs.includeEmailsTable.errorEmail = ''
      this.openDialog = false
    },
    clearFieldsAndClose() {
      this.closeModal()
      this.emails = cloneDeep(this.$refs.includeEmailsTable.defaultEmails)
    },
  },
}
</script>

<style scoped lang="scss">
.blue-action-text {
  color: $marca-0-l40;
  text-decoration: underline;
  text-align: right;
  &:hover {
    cursor: pointer;
  }
  font-size: 14px;
}

.email-subtitle {
  word-break: normal;
  font-size: 16px;
}
.export-button {
  border-radius: 8px;
}
.v-btn:not(.v-btn--round).v-size--default {
  padding: 10px 16px !important;
}
</style>
